// TKT-2285: forma comun de las 4 rutas del modulo de licencias (ver mas abajo).
// isLicencesManager: true ademas de isSuperAdmin: true -- un usuario role 12
// (Licences Manager, sin ser super admin) tambien puede entrar aqui, ver el
// guard en router/index.js. Las demas rutas de /admin no llevan esta marca:
// solo estas 4 son accesibles para un licences manager que no es super admin.
const licenseRoute = (path, name, component) => ({
  path,
  name,
  component,
  meta: { isSuperAdmin: true, isLicencesManager: true }
})

// Misma forma para las rutas del admin de Analytics.
const analyticsRoute = (path, name, component) => ({
  path,
  name,
  component,
  meta: { isSuperAdmin: true }
})

export default {
  path: '/admin',
  component: () => import('layouts/MainLayout.vue'),
  meta: {
    requiresAuth: true,
    isSuperAdmin: true
  },
  children: [
    {
      path: 'organizations',
      name: 'navigation.admin-organizations.index',
      component: () => import('pages/admin/organizations/Index.vue'),
      meta: {
        isSuperAdmin: true
      },
      children: [
        {
          path: 'organizations/edit/:organization_id',
          name: 'navigation.admin-organizations.edit',
          component: () => import('pages/admin/organizations/Organization.vue')
        },
        {
          path: 'organizations/new',
          name: 'navigation.admin-organizations.new',
          component: () => import('pages/admin/organizations/Organization.vue')
        }
      ]
    },
    {
      path: 'organizations_index',
      name: 'navigation.admin-organizations.index-table',
      component: () => import('pages/admin/organizations/IndexTable.vue'),
      meta: {
        isSuperAdmin: true
      }
    },
    {
      path: 'users',
      name: 'navigation.super-admin-users.index',
      component: () => import('pages/super-admin/users/Index.vue'),
      meta: { isSuperAdmin: true },
      children: [
        {
          path: 'users/edit/:user_id',
          name: 'navigation.super-admin-users.edit',
          component: () => import('pages/admin/users/User.vue')
        },
        { path: 'users/new/', name: 'navigation.super-admin-users.new', component: () => import('pages/admin/users/User.vue') }
      ]
    },
    {
      path: 'users_index',
      name: 'navigation.super-admin-users.index-table',
      component: () => import('pages/super-admin/users/IndexTable.vue'),
      meta: { isSuperAdmin: true }
    },
    // TKT-2285: fabrica local para las 4 rutas del modulo de licencias, todas con la misma forma
    // (path/name/componente lazy/meta.isSuperAdmin) -- evita que SonarCloud las marque como
    // bloques duplicados entre si.
    licenseRoute(
      'licenses', 'navigation.super-admin-licenses.index',
      () => import('@/pages/super-admin/LicenseOrganizationsPage.vue')
    ),
    licenseRoute(
      'licenses/:organization_id/franchises', 'navigation.super-admin-licenses.franchises',
      () => import('@/pages/super-admin/LicenseFranchisesPage.vue')
    ),
    // `franchise_id` es opcional: sin el, el alcance es la organizacion completa.
    licenseRoute(
      'licenses/:organization_id/users/:franchise_id?', 'navigation.super-admin-licenses.users',
      () => import('@/pages/super-admin/LicenseUsersPage.vue')
    ),
    // Vista independiente, no anidada bajo una organizacion: sus filtros de organizacion/unidad
    // de negocio son opcionales dentro de la propia pagina.
    licenseRoute(
      'licenses/report', 'navigation.super-admin-licenses.report',
      () => import('@/pages/super-admin/LicenseReportPage.vue')
    ),
    analyticsRoute(
      'analytics', 'navigation.super-admin-analytics.index',
      () => import('@/pages/super-admin/AnalyticsHubPage.vue')
    ),
    analyticsRoute(
      'analytics/dashboards/new', 'navigation.super-admin-analytics.dashboard-new',
      () => import('@/pages/super-admin/AnalyticsDashboardFormPage.vue')
    ),
    analyticsRoute(
      // El id solo admite dígitos: el param llega al path del request y no debe poder llevar `../`.
      'analytics/dashboards/:dashboard_id(\\d+)', 'navigation.super-admin-analytics.dashboard-edit',
      () => import('@/pages/super-admin/AnalyticsDashboardFormPage.vue')
    ),
    analyticsRoute(
      'analytics/organizations/:organization_id(\\d+)', 'navigation.super-admin-analytics.organization',
      () => import('@/pages/super-admin/AnalyticsOrganizationPage.vue')
    ),
    {
      path: 'users',
      name: 'navigation.super-admin-users.index',
      component: () => import('pages/admin/users/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'users/edit/:user_id',
      name: 'navigation.super-admin-users.edit',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'users/new/',
      name: 'navigation.super-admin-users.new',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'sprints',
      name: 'navigation.super-admin-sprints.index',
      component: () => import('pages/admin/sprints/Index.vue'),
      meta: {
        isSupervisor: true
      }
    },
    {
      path: 'campaigns',
      name: 'navigation.super-admin-campaigns.index',
      component: () => import('pages/admin/campaigns/Index.vue'),
      meta: {
        isSupervisor: true
      }
    },
    {
      path: 'campaigns/edit/:campaign_id',
      name: 'navigation.super-admin-campaigns.edit',
      component: () => import('pages/admin/campaigns/Campaign.vue'),
      meta: {
        isSupervisor: true
      }
    },
    {
      path: 'campaigns/new',
      name: 'navigation.super-admin-campaigns.new',
      component: () => import('pages/admin/campaigns/Campaign.vue'),
      meta: {
        isSupervisor: true
      }
    },
    {
      path: 'catalogs',
      name: 'navigation.super-admin-catalogs.index',
      component: () => import('pages/admin/catalogs/Index.vue'),
      meta: {
        isAdmin: true
      }
    }, {
      path: 'catalogs/edit/:catalog_id',
      name: 'navigation.super-admin-catalogs.edit',
      component: () => import('pages/admin/catalogs/Catalog.vue'),
      meta: {
        isAdmin: true
      }
    }, {
      path: 'catalogs/new',
      name: 'navigation.super-admin-catalogs.new',
      component: () => import('pages/admin/catalogs/Catalog.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms',
      name: 'navigation.super-admin-forms.index',
      component: () => import('pages/admin/forms/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms/edit/:form_id',
      name: 'navigation.super-admin-forms.edit',
      component: () => import('pages/admin/forms/Form.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms/new/',
      name: 'navigation.super-admin-forms.new',
      component: () => import('pages/admin/forms/Form.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms/build/:form_id/:source_form_id',
      name: 'navigation.super-admin-forms.build-cloned',
      component: () => import('pages/admin/forms/FormBuild.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms/build/:form_id/',
      name: 'navigation.super-admin-forms.build',
      component: () => import('pages/admin/forms/FormBuild.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'forms/preview/:form_id',
      name: 'navigation.super-admin-forms.preview',
      component: () => import('pages/admin/forms/FormPreview.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'franchises',
      name: 'navigation.super-admin-franchises.index',
      component: () => import('pages/admin/franchises/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'franchises/edit/:franchise_id',
      name: 'navigation.super-admin-franchises.edit',
      component: () => import('pages/admin/franchises/Franchise.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'franchises/new/',
      name: 'navigation.super-admin-franchises.new',
      component: () => import('pages/admin/franchises/Franchise.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'locations',
      name: 'navigation.super-admin-locations.index',
      component: () => import('pages/admin/locations/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'locations/edit/:location_id',
      name: 'navigation.super-admin-locations.edit',
      component: () => import('pages/admin/locations/Location.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'locations/new/',
      name: 'navigation.super-admin-locations.new',
      component: () => import('pages/admin/locations/Location.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'locations/groups/',
      name: 'navigation.super-admin-locations.groups',
      component: () => import('pages/admin/locations/Groups.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'roles',
      name: 'navigation.super-admin-roles.index',
      component: () => import('pages/admin/roles/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'roles/edit/:role_id',
      name: 'navigation.super-admin-roles.edit',
      component: () => import('pages/admin/roles/Role.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'roles/new/',
      name: 'navigation.super-admin-roles.new',
      component: () => import('pages/admin/roles/Role.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'users',
      name: 'navigation.super-admin-users.index',
      component: () => import('pages/admin/users/Index.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'users/edit/:user_id',
      name: 'navigation.super-admin-users.edit',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'users/new/',
      name: 'navigation.super-admin-users.new',
      component: () => import('pages/admin/users/User.vue'),
      meta: {
        isAdmin: true
      }
    },
    {
      path: 'mailing',
      name: 'navigation.super-admin-mailing.index',
      component: () => import('pages/admin/mailing/Index.vue'),
      meta: {
        isAdmin: true
      }
    }
  ]
}
